import React, { Component } from 'react';

function withForm(FormComponent, formConfig) {
  return class extends Component {
    constructor(props) {
      super(props);
      const fields = Object.keys(formConfig.fields);
      const formInputData = fields.reduce((formInputData, formFieldName) => ({
        ...formInputData,
        [formFieldName]: '',
      }), {});
      const errors = fields.reduce((errors, formFieldName) => ({
        ...errors,
        [formFieldName]: {
          hasError: false,
          isPristine: true,
          message: '',
        },
      }), {});
      this.state = {
        formInputData,
        errors,
      };
    }

    handleChange = event => {
      //console.log(event.target.name);
      const targetName = event.target.name;
      const targetValue = event.target.value;
      const formInputData = {
        ...this.state.formInputData,
        [targetName]: targetValue,
      };
      let errors = {
        ...this.state.errors,
      };
      if (formConfig.fieldValidators[targetName]) {
        if (formConfig.fieldValidators[targetName](targetValue)) {
          errors = {
            ...errors,
            [targetName]: {
              ...errors[targetName],
              hasError: false,
              message: '',
            },
          };
        } else {
          errors = {
            ...errors,
            [targetName]: {
              ...errors[targetName],
              hasError: true,
              message: formConfig.fieldErrorMessages[targetName].validation,
            },
          };
        }
      } else {
        errors = {
          ...errors,
          [targetName]: {
            ...errors[targetName],
            hasError: false,
            message: '',
          },
        };
      }
      this.setState(prevState => ({
        formInputData,
        errors,
      }));
    }

    handleBlur = targetName => {
      let errors = {
        ...this.state.errors,
        [targetName]: {
          ...this.state.errors[targetName],
          isPristine: false,
        },
      };
      if (this.state.formInputData[targetName] === '') {
        if (formConfig.fields[targetName].required) {
          errors = {
            ...errors,
            [targetName]: {
              ...errors[targetName],
              hasError: true,
              message: formConfig.fieldErrorMessages[targetName].required,
            },
          };
        } else {
          errors = {
            ...errors,
            [targetName]: {
              ...errors[targetName],
              hasError: false,
              message: '',
            },
          };
        }
      }
      this.setState({
        errors,
      });
    }

    isFormValid = errors => {
      const keys = Object.keys(errors);
      let valid = true;
      keys.forEach(key => {
        if (errors[key].isPristine || errors[key].hasError) {
          valid = false;
        }
      });
      return valid;
    };

    render() {
      return (
        <FormComponent
          formInputData={this.state.formInputData}
          handleChange={this.handleChange}
          handleBlur={this.handleBlur}
          errors={this.state.errors}
          formValid={this.isFormValid(this.state.errors)}
          {...this.props}
        />
      );
    }
  };
}

export default withForm;